import Box from '@mui/material/Box'
import {
  borderRadius,
  colors,
  KestrixTextField,
  KestrixTypography
} from '@shared'
import { useState } from 'react'

import { ShowPasswordButton } from './ShowPasswordButton'
type LoginInputProps = {
  inputName: string
  inputValue: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  isDisabled: boolean
  isPassword?: boolean
  error: string
}

export const LoginInput = ({
  inputName,
  inputValue,
  onChange,
  isDisabled,
  isPassword = false,
  error
}: LoginInputProps) => {
  const [hidePassword, setHidePassword] = useState(isPassword)
  const togglePasswordVisibility = () => {
    setHidePassword(!hidePassword)
  }
  return (
    <Box sx={{ mb: 3 }}>
      <KestrixTypography
        variant="body1"
        color="subtitle"
        weight="semibold"
        align="left"
        mb={1.5}
      >
        {inputName}
      </KestrixTypography>
      <KestrixTextField
        placeholder={`Enter your ${inputName}`}
        variant="outlined"
        size="medium"
        value={inputValue}
        type={hidePassword ? 'password' : 'text'}
        onChange={onChange}
        disabled={isDisabled}
        error={!!error && error.includes(`${inputName.toLowerCase()}`)}
        InputProps={{
          'aria-label': `${inputName}`,
          'aria-required': 'true',
          autoComplete: `${inputName.toLowerCase()}`,
          'data-testid': `${inputName.toLowerCase()}-input`,
          endAdornment: isPassword && (
            <ShowPasswordButton
              showPassword={!hidePassword}
              togglePasswordVisibility={togglePasswordVisibility}
            />
          )
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: borderRadius.md,
            '&:hover': {
              boxShadow: `0 0 0 3px ${colors.base.KestrixPrimary}15`
            },
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${colors.base.KestrixPrimary}25`
            }
          }
        }}
      />
    </Box>
  )
}
